import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let BulkEditHouseComponent = {
    selector: "vcBulkEditHouse",
    templateUrl: "/angular/components/house/bulk-edit-house.component.html",
    bindings: {
        numItems: "=",
    },
    controller: class BulkEditHouseController {
        // * bindings for typescript compiler *
        public numItems: any;
        // ************************************

        private itemText: string;
        private fields: any;
        private fieldEdit: any = {
            value: null,
        };

        private dialog: DialogUtils;
        private readonly $filter: any;

        constructor($filter: any, DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
            this.$filter = $filter;

            this.fields = [
                {
                    name: "Number",
                    type: "Number",
                    hokey: "hnumber",
                },
                {
                    name: "Name",
                    type: "Text",
                    hokey: "hname",
                },
                {
                    name: "Street",
                    type: "Text",
                    hokey: "haddress",
                },
                {
                    name: "City",
                    type: "Text",
                    hokey: "hcity",
                },
                {
                    name: "State",
                    type: "Text",
                    hokey: "hstate",
                },
                {
                    name: "Unit",
                    type: "Text",
                    hokey: "hunit",
                },
                {
                    name: "Floor",
                    type: "Text",
                    hokey: "hfloor",
                },
                {
                    name: "Zip Code",
                    type: "Text",
                    hokey: "hzipcode",
                },
                {
                    name: "Precinct",
                    type: "Text",
                    hokey: "hprecinct",
                },
            ];
        }

        $onInit() {
            this.itemText =
                this.numItems > 1
                    ? `${this.numItems} houses`
                    : `${this.numItems} house`;
        }

        setSelectedField(field: any) {
            this.fieldEdit.field = field;
            this.fieldEdit.value = null;
        }

        clearAll() {
            this.fieldEdit.field.options.forEach((option: any) => {
                if (angular.isDefined(option.selected) && option.selected) {
                    option.selected = false;
                }
            });
            this.fieldEdit.value = "";
        }

        confirm(): void {
            const edit = this.dialog
                .confirm()
                .title(`Bulk edit field`)
                .htmlContent(
                    `Edit the "${this.fieldEdit.field.name}" field for ${this.itemText}? <br/> <b>This action cannot be undone.</b>`
                )
                .multiple(true)
                .ok("Confirm")
                .cancel("Cancel");
            this.dialog.show(edit).then(() => {
                this.dialog.hide(this.fieldEdit);
            });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("house")
    .component(BulkEditHouseComponent.selector, BulkEditHouseComponent);
